import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { IconButton } from '@material-ui/core';

import { ReactComponent as Dots } from '../Pics/iconsManagement/dots.svg';

export default function TaskMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (m) => {
        setAnchorEl(null);

        props.callBack(m)
    };

    return (
        <div>
            <IconButton
                style={{ padding: 1, marginTop: 3, backgroundColor: 'white', borderRadius:'50%' }}
                aria-controls='simple-menu' aria-haspopup="true" onClick={handleClick}>
                    <Dots style={{ width:30, height:30,  color: 'black' }} />
                {/* <i  className='material-icons'>
                    linear_scale
                                    </i> */}
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >

                {props.menuItems.map((m, idx) => {
                    return (
                        <MenuItem key={idx} value={m.id} onClick={()=>{handleClose(m)}}>{m.name}</MenuItem>
                    )
                })}


     
            </Menu>
        </div>
    );
}